import { render } from "./headmasterStudioState.vue?vue&type=template&id=de129ff0&scoped=true"
import script from "./headmasterStudioState.vue?vue&type=script&lang=js"
export * from "./headmasterStudioState.vue?vue&type=script&lang=js"

import "./headmasterStudioState.vue?vue&type=style&index=0&id=de129ff0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de129ff0"]])

export default __exports__